import http from "../utils/axios";
// 文件上传，基础上传
export const upload = data => {
  return http({
    url: "/api/upload/upload", // 接口
    method: "post",
    data: data
  });
};
